import { cn } from "@/lib/utils";

interface NotificationBadgeProps {
  count: number;
  className?: string;
}

export function NotificationBadge({ count, className }: NotificationBadgeProps) {
  if (count === 0) return null;

  const displayCount = count > 9 ? "9+" : count.toString();

  return (
    <span
      className={cn(
        "absolute flex items-center justify-center",
        "min-w-[18px] h-[18px] px-1",
        "text-[10px] font-semibold leading-none",
        "bg-accent text-accent-foreground",
        "rounded-full",
        "-top-0.5 -right-0.5",
        className
      )}
    >
      {displayCount}
    </span>
  );
}
